<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        :title='item.data === undefined ? "政策添加" : "政策编辑" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='700'
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-text-field :rules="required" hide-details="auto" label="政策标题" v-model="form.title" outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-select
                  :items="levelItems"
                  label="政策级别"
                  v-model="form.level"
                  hide-details='auto'
                  outlined
                  :rules="required"
                  @change='levelChange'
                ></v-select>
              </v-col>
              <v-col cols="9">
                <area-select
                  placeholder="政策发布地选择"
                  v-model="form.areas"
                  :data="areaItems"
                  type='all'
                  :level="form.level"
                  @change='areaChange'
                  v-if="showAreaSelect"
                >
                </area-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <base-material-date
                  ref='date'
                  hide-details='auto'
                  outlined
                  :rules="required"
                  label='发稿时间'
                  clear-icon="mdi-close-circle-outline"
                  v-model='form.publishTimeStr'
                >
                </base-material-date>
              </v-col>
              <v-col cols="6">
                <v-text-field :rules="required" hide-details="auto" label="补贴金额(万元)" placeholder="例如 1~10" v-model="form.subsidy" outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-select-search
                  hide-details='auto'
                  label="开始时间(政策可申请开始时间)"
                  :data="monthItems"
                  item-text="label"
                  item-value="value"
                  outlined
                  clearable
                  :rules="required"
                  clear-icon="mdi-close-circle-outline"
                  v-model='form.startMonth'>
                </v-select-search>
              </v-col>
              <v-col cols="6">
                <v-select-search
                  hide-details='auto'
                  label="截止时间(政策可申请截止时间)"
                  :data="monthItems"
                  item-text="label"
                  item-value="value"
                  clearable
                  outlined
                  :rules="required"
                  clear-icon="mdi-close-circle-outline"
                  v-model='form.endMonth'>
                </v-select-search>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span style="color:red">以下信息为满足此政策的最低标准！</span>
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field :rules="number" hide-details="auto" label="知识产权数量" v-model="form.patentNumber" outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field :rules="number" hide-details="auto" label="固定资产" v-model="form.fixedAssets" outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-autocomplete
                :items="seniorityItems"
                label="其他资质要求"
                v-model="form.seniorityIdList"
                hide-details='auto'
                outlined
                multiple
                item-text='title'
                item-value="id"
                @change="seniorityChange"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field :rules="number" hide-details="auto" label="资产总额(万元)" v-model="form.assets" outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field :rules="number" hide-details="auto" label="净资产额(万元)" v-model="form.netAssets" outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field :rules="number" hide-details="auto" label="营业收入(万元)" v-model="form.income" outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field :rules="number" hide-details="auto" label="主营业务收入(万元)" v-model="form.firstIncome" outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field :rules="number" hide-details="auto" label="利润总额(万元)" v-model="form.profit" outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field :rules="number" hide-details="auto" label="净利润(万元)" v-model="form.netProfit" outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field :rules="number" hide-details="auto" label="研发费用(万元)" v-model="form.development" outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field :rules="number" hide-details="auto" label="研发费用占比(百分制)" v-model="form.developmentRatio" outlined></v-text-field>
              </v-col>
            </v-row>
             <v-row>
              <v-col>
                <v-select
                  :items="typeItems"
                  label="文件归属"
                  v-model="form.typeId"
                  hide-details='auto'
                  outlined
                  item-text='name'
                  item-value="id"
                  :rules="required"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea :rules="required" rows='7' label="申请条件描述" hide-details='auto' outlined v-model="form.abstracts"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions class="pt-5 px-0">
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { getByPids } from '@/api/system/dictionary.js'
  import { save, policys } from '@/api/policy/index.js'
  import { selectMonthData } from '@/utils/tool.js'
  import VSelectSearch from '@/components/select/v-select-search.vue'

  import {
    ResetObject,
    isEmpty
  } from '@/utils/stringUtil.js'

  export default {
    name: 'PolicyEdit',
    components: {
      VSelectSearch
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        chosenFile: null,
        loading: false,
        required: [
          value => (!!value || value === 0) || '此项为必填项!'
        ],
        number: [
          value => /^[0-99]*$/.test(value) || '请输入数字',
        ],
        monthItems: selectMonthData(),
        typeItems: [],
        levelItems: [
          { text: '省级', value: 0 },
          { text: '市级', value: 1 },
          { text: '区县级', value: 2 },
          { text: '国家级', value: 3 }
        ],
        seniorityItems: [],
        showAreaSelect: false,
        form: {
          id: '',
          title: '',
          typeId: '',
          subsidy: '',
          abstracts: '',
          areas: [],
          area: '',
          areaCode: '',
          level: 2,
          startMonth: '',
          endMonth: '',
          publishTime: '',
          publishTimeStr: '',
          income: '',
          firstIncome: '',
          profit: '',
          netProfit: '',
          assets: '',
          netAssets: '',
          development: '',
          patentNumber: '',
          seniorityIds: '',
          seniorityStr: '',
          seniorityIdList: [],
          fixedAssets: '',
          developmentRatio: ''
        }
      }
    },
    methods: {
      save () {
        this.buildForm()
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      buildForm () {
        if (!isEmpty(this.form.publishTimeStr)) {
          this.form.publishTime = new Date(this.form.publishTimeStr).getTime() / 1000
        }
        this.form.seniorityIds = JSON.stringify(this.form.seniorityIdList)
      },
      seniorityChange (arr) {
        const this_ = this
        this_.form.seniorityStr = ''
        this.seniorityItems.forEach(item => {
          arr.forEach(id => {
            if (item.id === id) {
              this_.form.seniorityStr += `${item.title},`
            }
          })
        })
        this_.form.seniorityStr = this_.form.seniorityStr.substring(0, this_.form.seniorityStr.lastIndexOf(','))
        console.log(this_.form.seniorityStr)
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form = JSON.parse(JSON.stringify(this.item.data))
          }
          if (this.form.level !== 3) {
            this.showAreaSelect = true
          }
          this.policys()
        } else {
          this.showAreaSelect = false
          ResetObject(this.form)
        }
      },
      levelChange (val) {
        this.showAreaSelect = false
        if (val !== 3) {
          this.showAreaSelect = true
        }
      },
      areaChange (selected) {
        this.form.areaCode = []
        this.form.area = []
        const this_ = this
        selected.forEach(area => {
          for (const st in area) {
            this_.form.areaCode.push(st)
            this_.form.area.push(area[st])
          }
        })
        this.form.areaCode = this.form.areaCode.toString()
        this.form.area = this.form.area.toString().replaceAll(',', '/')
      },
      policys () {
        this.loading = true
        policys({}).then(res => {
          if (res.status === 200) {
            this.seniorityItems = res.data
          }
          this.loading = false
        })
      },
      getTypes () {
        getByPids(
          {
            pids: [
              this.$constants.policyTypePid
            ]
          }
        ).then(res => {
          if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
             if (this_.$constants.policyTypePid === result.id) {
                this_.typeItems = result.data
             }
           })
          }
        })
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      },
      areaItems () {
        return require('@/assets/json/area_henan.json')
      }
    },
    created() {
      this.getTypes()
    }
  }
</script>

<style lang="sass" scoped>
</style>
